<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form inline class="inline-form">
          <el-form-item label="结算时间">
            <date-range-picker v-model="settleTime" :value="settleTime" :disabled-before-date="disabledBeforeDate" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="交易单号">
            <el-input
              class="search-input"
              v-model="orderId"
              placeholder="交易单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              clearable
              filterable
              remote
              :remote-method="handleMerchantInfoRemote"
              :loading="selectLoading">
              <el-option
                v-for="item in subMerchantNamesList"
                :key="item.fmerchantId"
                :label="item.fmerchantId"
                :value="item.fmerchantId">
                <span class="value">{{ item.fmerchantId }}</span>
                <span class="name">{{ item.fmerchantName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <payment-type
            :payType="searchInfo.payType"
            :payChannel="searchInfo.paymentType"
            @getPayType="getPayType"
            @getPayChannel="getPaymentType"></payment-type>
          <el-form-item label="交易状态">
            <el-select style="width: 150px;" v-model="operatorType" clearable>
              <div v-if="searchInfo.payType === 0">
                <el-popover
                  placement="right"
                  title=""
                  width="200"
                  trigger="hover"
                  content="退款包括退款中和退款成功两种状态，可通过“交易数据查询”查询">
                  <el-option slot="reference" label="退款" value="1"></el-option>
                </el-popover>
                <el-option label="支付成功" value="2"></el-option>
                <el-option label="退款失败" value="3"></el-option>
              </div>
              <div v-else>
                <el-option label="交易成功" value="0"></el-option>
                <el-popover
                  placement="right"
                  title=""
                  width="200"
                  trigger="hover"
                  content="退款包括退款中和退款成功两种状态，可通过“交易数据查询”查询">
                  <el-option slot="reference" label="退款" value="1"></el-option>
                </el-popover>
                <el-option label="退款失败" value="2"></el-option>
                <el-option label="撤销成功" value="3"></el-option>
                <el-option label="撤销失败" value="4"></el-option>
                <el-option label="冲正成功" value="5"></el-option>
                <el-option label="预授权完成" value="6"></el-option>
                <el-option label="预授权完成冲正" value="7"></el-option>
                <el-option label="预授权完成通知" value="8"></el-option>
                <el-option label="预授权完成撤销" value="9"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="应结订单金额(元)">
            <el-input
              style="width:100px;"
              v-model="minAmount"
              auto-complete="off"
              placeholder="正整数"></el-input> -
            <el-input
              style="width:100px;"
              v-model="maxAmount"
              auto-complete="off"
              placeholder="正整数"></el-input>
          </el-form-item>
          <el-form-item label="手续费是否封顶">
            <el-select style="width: 120px;" v-model="maxFeeFlag" clearable>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
            <auth-button
              icon="el-icon-download"
              opt="export"
              :plain="true"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 汇总 -->
      <el-col>
        <div class="sum-view">
          <div>
            <div class="sum-item-title">应结订单金额</div>
            <div>{{ totalInfo.totalAmountStr || '--' }}</div>
          </div>
          <div>
            <div class="sum-item-title">手续费总额</div>
            <div>{{ totalInfo.totalCommissionAmountStr || '--' }}</div>
          </div>
          <div>
            <div class="sum-item-title">结算金额</div>
            <div>{{ totalInfo.totalSettleAmountStr || '--' }}</div>
          </div>
        </div>
      </el-col>
      <el-col>
        <div class="search-tips">注：仅支持查询一年以内明细数据，若需查询超过一年数据，请联系乐刷运营；导出最大支持100000条数据</div>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- table -->
      <el-table
        stripe
        style="width:100%;"
        v-loading="tableLoading"
        :data="orderBillingDetailsList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="ftime"
          label="结算时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="forderId"
          label="交易单号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fmerchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="paymentType"
          label="交易类型"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="traderStatus"
          label="交易状态"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="amountStr"
          label="应结订单金额"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="merchantRateStr"
          label="商户费率"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="commissionFixedStr"
          label="单笔提现手续费"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.commissionFixedStr || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fmaxFeeFlag"
          label="手续费是否封顶"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.fmaxFeeFlag | formatMaxFeeFlag }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="commissionAmountStr"
          label="手续费总额"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="settleAmountStr"
          label="结算金额"
          align="center"
          min-width="150">
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :size="paginations.pageSize" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import paymentType from '@/components/paymentType/paymentType'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { listAgentMerchant, listMerchantStatement, exportMerchantStatement } from '@/api/settle'

export default {
  name: 'OrderBillingDetails',
  components: {
    paymentType,
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        agentId: '',
        merchantId: '',
        orderId: '',
        payType: 0,
        paymentType: '1, 2, 5',
        state: '',
        minAmount: '',
        maxAmount: ''
      },
      settleTime: [todayZeroStr, todayStr],
      subAgentId: '',
      merchantId: '',
      orderId: '',
      // paymentType: '',
      maxAmount: '',
      minAmount: '',
      operatorType: '',
      maxFeeFlag: '',
      tableLoading: false,
      selectLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      orderBillingDetailsList: [],
      totalInfo: {},
      disabledBeforeDate: new Date().setFullYear(new Date().getFullYear() - 1)
    }
  },
  watch: {
    paginations: {
      handler (val) {
        console.log(val)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    // this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      this.loading = true
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    validAmount () {
      var num = /^[0-9]+$/
      if (this.minAmount !== '' && (!num.test(this.minAmount))) {
        this.minAmount = ''
        this.$message({
          showClose: true,
          message: '应结订单金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.maxAmount !== '' && (!num.test(this.maxAmount))) {
        this.maxAmount = ''
        this.$message({
          showClose: true,
          message: '应结订单金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.minAmount !== '' && this.maxAmount !== '') {
        if (parseInt(this.minAmount) > parseInt(this.maxAmount)) {
          this.maxAmount = ''
          this.$message({
            showClose: true,
            message: '最大应结订单金额不能小于最小金额',
            type: 'warning'
          })
          return false
        }
      }
      return true
    },
    /**
     * 交易类型选择change
     */
    payTypeSelectChange (value) {
      if (value === 0) {
        this.payChannel = [1, 2, 5]
      }
      if (value === 1) {
        this.payChannel = [0]
      }
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      if (!this.merchantId) {
        this.$message({
          message: '请先输入商户编号',
          type: 'warning'
        })
        return
      }
      console.log('查询点击')
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(noReset)
      // const startDate = new Date(this.searchInfo.startTime)
      // const minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      // if (minDate.getTime() - startDate.getTime() > 0 && new Date(this.searchInfo.endTime) - startDate.getTime() > 5 * 24 * 60 * 60 * 1000) {
      //   this.$message({
      //     message: '一年前数据请选择五天内数据进行筛选',
      //     type: 'error'
      //   })
      //   return
      // }
      this.listMerchantStatement()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      if (!this.merchantId) {
        this.$message({
          message: '请先输入商户编号',
          type: 'warning'
        })
        return
      }
      console.log('查询点击')
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(true)
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      const startDate = new Date(this.searchInfo.startTime)
      const minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      if (minDate.getTime() - startDate.getTime() > 0) {
        this.$message({
          message: '请选择近一年时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportMerchantStatement()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.minAmount = this.minAmount || ''
      this.searchInfo.maxAmount = this.maxAmount || ''
      this.searchInfo.startTime = this.settleTime && this.settleTime[0] ? this.settleTime[0] : ''
      this.searchInfo.endTime = this.settleTime && this.settleTime[1] ? this.settleTime[1] : ''
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.searchInfo.endTime = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
        this.searchInfo.startTime = parseTime(new Date(new Date().setFullYear(new Date().getFullYear() - 1) + 3600 * 1000 * 24), '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
      }
      this.searchInfo.agentId = this.subAgentId || ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.orderId = this.orderId.replace(/ /g, '') || ''
      // this.searchInfo.paymentType = this.paymentType
      this.searchInfo.operatorType = this.operatorType || ''
      this.searchInfo.maxFeeFlag = this.maxFeeFlag || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      // if (value !== null) {
      //   if ((value[0] == value[1])) {
      //     value[0] = value[0].substring(0,10)+' 00:00:00';
      //     value[1] = value[1].substring(0,10)+' 23:59:59';
      //   }
      // }
      this.settleTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 商户信息自定义筛选方法
     */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.listAgentMerchant(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
     * 获取代理商下所有商户列表
     */
    listAgentMerchant (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      console.log(params)
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          console.log('listAgentMerchant response:', response)
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      })
    },
    /**
     * 商户订单计费明细查询
     */
    listMerchantStatement () {
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 31) {
      //   this.$message({
      //     message: '请筛选1个月内的交易进行查询',
      //     type: 'error'
      //   })
      //   return
      // }
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      listMerchantStatement(params).then(response => {
        console.log('listMerchantStatement response:', response)
        this.loading = false
        if (parseInt(response.result_cde) === 0) {
          this.orderBillingDetailsList = response.list
          this.totalInfo = {
            totalAmountStr: response.totalAmountStr,
            totalCommissionAmountStr: response.totalCommissionAmountStr,
            totalSettleAmountStr: response.totalSettleAmountStr
          }
          this.paginations.count = response.totalCount
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 商户订单计费明细导出
     */
    exportMerchantStatement () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 2,
        moduleName: '结算',
        menuName: '订单计费明细'
      }))
      console.log(params)
      exportMerchantStatement(params).then(response => {
        this.exportButtonLoading = false
        if (parseInt(response.result_cde) === 0) {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    },
    // 获取组件中交易类型及交易渠道选中值
    getPayType (val) {
      if (val !== this.searchInfo.payType) this.operatorType = ''
      this.searchInfo.payType = val
    },
    getPaymentType (val) {
      this.searchInfo.paymentType = val
    }
  },
  computed: {},
  filters: {
    formatMaxFeeFlag (value) {
      switch (value) {
        case 0:
          return '否'
        case 1:
          return '是'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.sum-view {
  margin: 10px;
  text-align: center;
  font-size: 14px;
  display: flex;
  justify-items: center;
  justify-content: space-around;
}
.sum-item-title {
  font-weight: 700;
  margin-bottom: 30px;
}
</style>
